export const pageReducer = (
  state = {
    pages: null,
    pageDetail: null,
    versions: null,
    accessCode: null,
    loading: false,
    error: null,
  },
  action
) => {
  switch (action.type) {
    case "GET_PAGES_LIST_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_PAGES_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        pages: action.payload,
        error: null,
      };
    case "GET_PAGES_LIST_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_PAGES_VERSIONS_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_PAGES_VERSIONS_SUCCESS":
      return {
        ...state,
        loading: false,
        versions: action.payload,
        error: null,
      };
    case "GET_PAGES_VERSIONS_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "ADD_PAGE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "ADD_PAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "ADD_PAGE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "VIEW_PAGE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        pageDetail: null,
      };
    case "VIEW_PAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        pageDetail: action.payload,
        error: null,
      };
    case "VIEW_PAGE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        pageDetail: null,
      };

    case "UPDATE_PAGE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "UPDATE_PAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "UPDATE_PAGE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "DELETE_PAGE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "DELETE_PAGE_SUCCESS":
      return {
        ...state,
        loading: false,
        error: null,
      };
    case "DELETE_PAGE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case "GET_ACCESS_CODE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "GET_ACCESS_CODE_SUCCESS":
      return {
        ...state,
        loading: false,
        accessCode: action.payload.data,
        error: null,
      };
    case "GET_ACCESS_CODE_FAILED":
      return {
        ...state,
        loading: false,
        error: action.payload,
        accessCode: null,
      };

    default:
      return state;
  }
};
